<template>
  <div id="params_manage" class="h100">
    <div class="search_box">
      <span class="vertical-bar fn18 fnM">参数管理</span>
      <el-button
        size="small"
        class="float-right"
        type="primary"
        style="width: 102px"
        @click="openAddDialog"
      >
        新增参数
      </el-button>
      <el-input
        v-model="tableSearch"
        size="small"
        placeholder="请输入关键字"
        class="float-right"
        style="width: 303px; margin-right: 8px"
        @keyup.enter.native="getTableList"
      >
        <i slot="suffix" style="padding-right: 8px" @click="getTableList">
          <svg-icon icon-class="input_search"></svg-icon>
        </i>
      </el-input>
    </div>

    <customTable
      :table-data="tableData"
      :pagination="pagination"
      @handleSizeChange="handlePaginationChange"
      @handleCurrentChange="handlePaginationChange"
    >
      <el-table-column prop="configName" label="参数名称" :show-overflow-tooltip="true" />
      <el-table-column label="参数编码" prop="configKey" :show-overflow-tooltip="true" />
      <el-table-column prop="configValue" label="参数值" width="90" />
      <el-table-column prop="systemDefault" label="类型" width="90">
        <template slot-scope="scope"  width="90">
          {{ scope.row.systemDefault ? "系统" : "业务" }}
        </template>
      </el-table-column>
      <el-table-column prop="state" label="状态" width="90">
        <template slot-scope="scope">
          {{ scope.row.enabled ? "启用" : "停用" }}
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述" :show-overflow-tooltip="true" min-width="100" />
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="text"
            style="padding: 0; height: auto"
            @click="openEdit(scope.row)"
          >
            {{ $t("public.edit") }}
          </el-button>
          <el-dropdown
            trigger="hover"
            @command="
              (com) => {
                treeCommand(com, scope.row);
              }
            "
          >
            <i class="el-icon-more" style="margin-right: 4px"></i>
            <el-dropdown-menu slot="dropdown" :visible-arrow="false" class="resource_popover">
              <el-dropdown-item command="delete" class="delete_hover">
                <span>{{ $t("public.delete") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </customTable>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="dataEdit ? '编辑参数' : '新增参数'"
      :visible.sync="dataDialogVisible"
      class="data_dialog"
    >
      <el-form
        ref="dataForm"
        label-position="top"
        size="small"
        :model="dataForm"
        :rules="dataRules"
      >
        <el-row :gutter="32">
          <el-col :span="12">
            <el-form-item label="参数名称" prop="configName">
              <el-input v-model="dataForm.configName" placeholder="请输入">
                <i slot="suffix">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    content="4-30个字符（一个汉字算两个字符）"
                  >
                    <svg-icon class="suffix_icon" icon-class="info_icon"></svg-icon>
                  </el-tooltip>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item label="参数值" prop="configValue">
              <el-input v-model="dataForm.configValue" placeholder="请输入">
                <i slot="suffix">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    content="支持字母、数字、中划线、下划线"
                  >
                    <svg-icon class="suffix_icon" icon-class="info_icon"></svg-icon>
                  </el-tooltip>
                </i>
              </el-input>
            </el-form-item>
            <el-form-item label="参数类型" prop="systemDefault">
              <el-select
                v-model="dataForm.systemDefault"
                placeholder="请选择类型"
                style="width: 100%"
              >
                <el-option label="系统" :value="true"></el-option>
                <el-option label="业务" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参数编码" prop="configKey">
              <el-input v-model="dataForm.configKey" placeholder="请输入">
                <!-- <i slot="suffix">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    content="可显示多个名称，每个名称以顿号“、”间隔"
                  >
                    <svg-icon class="suffix_icon" icon-class="info_icon"></svg-icon>
                  </el-tooltip>
                </i> -->
              </el-input>
            </el-form-item>
            <el-form-item label="状态" prop="enabled">
              <el-select v-model="dataForm.enabled" placeholder="请选择状态" style="width: 100%">
                <el-option label="启用" :value="true"></el-option>
                <el-option label="停用" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="dataForm.description"
                type="textarea"
                :rows="3"
                placeholder="请输入描述信息，限50字以内"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="padding: 0 16px 16px 16px; margin-top: 0">
        <el-button
          plain
          size="small"
          class="plain_button"
          style="width: 80px"
          @click="dataDialogVisible = false"
        >
          {{ $t("public.cancel") }}
        </el-button>
        <el-button type="primary" size="small" style="width: 80px" @click="dialogSubmit">
          {{ $t("public.confirm") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog v-dialogDrag :visible.sync="deleteVisible" class="delete_dialog">
      <div class="warning_title fnM fn16">
        <svg-icon class="before_icon" icon-class="dialog_warning"></svg-icon>
        <span v-if="batchDeleteInfo.length === 0">
          确认要删除参数“{{ deleteInfo.configName }}”吗？
        </span>
        <span v-if="batchDeleteInfo.length > 0">
          确认要删除选中的{{ batchDeleteInfo.length }}条数据源吗？
        </span>
      </div>
      <p class="delete_tips">删除后将无法恢复。</p>
      <div slot="footer" class="dialog-footer" style="margin-top: 36px">
        <el-button plain size="small" style="width: 80px" @click="deleteVisible = false">
          {{ $t("public.cancel") }}
        </el-button>
        <el-button type="danger" plain size="small" style="width: 80px" @click="deleteSubmit">
          {{ $t("public.confirm") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import data_api from "@/api/data-permission/dataPermission";
import { Message } from "element-ui";
export default {
  name: "ParamsManage",
  data() {
    return {
      dataEdit: false,
      dataDialogVisible: false,
      dataForm: {
        displayData: ""
      },
      dataRules: {
        configName: [
          { required: true, message: "参数名称不能为空", trigger: "blur" },
          {
            min: 4,
            max: 30,
            message: "字符长度应为4-30",
            trigger: "change"
          }
        ],
        configKey: [{ required: true, message: "参数编码不能为空", trigger: "blur" }],
        configValue: [
          { required: true, message: "参数值不能为空", trigger: "blur" }
          // { validator: checkUrl, trigger: "blur" },
        ],
        systemDefault: [{ required: true, message: "请选择参数类型", trigger: "blur" }],
        enabled: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      deleteVisible: false,
      deleteInfo: {},
      batchDeleteInfo: [],
      previewVisible: false,
      tableData: [],
      tableSearch: "",
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableKeys: []
    };
  },
  watch: {
    dataDialogVisible(val) {
      if (!val) {
        this.dataForm = {};
        this.$refs.dataForm.clearValidate();
      }
    }
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 获取table列表
    getTableList() {
      const data = {
        search: this.tableSearch,
        page: this.pagination.pageNum,
        size: this.pagination.pageSize
      };
      data_api.getParamsList(data).then(res => {
        console.log(res);
        this.tableData = res.data.records;
        this.pagination.total = parseInt(res.data.total);
      });
    },
    // 分页
    handlePaginationChange(data) {
      this.pagination = data;
      this.getTableList();
    },
    // 删除table元素
    deleteDataInfo(keys) {
      data_api.deleteParamsItem({ keys }).then(res => {
        this.pagination.pageNum = 1;
        this.deleteVisible = false;
        Message.success("删除成功");
        this.getTableList();
      });
    },
    // 列表选项
    treeCommand(com, obj) {
      console.log(com);
      if (com === "delete") {
        this.batchDeleteInfo = [];
        this.deleteVisible = true;
        this.deleteInfo = obj;
      }
    },
    // 打开编辑弹窗
    openEdit(obj) {
      this.dataEdit = true;
      this.dataForm = { ...obj };
      this.dataDialogVisible = true;
    },
    // 打开新增弹窗
    openAddDialog() {
      this.dataEdit = false;
      this.dataDialogVisible = true;
    },
    // 弹窗删除
    deleteSubmit() {
      if (this.batchDeleteInfo.length > 0) {
        this.deleteDataInfo(this.batchDeleteInfo.map(item => item.id));
      } else {
        this.deleteDataInfo([this.deleteInfo.id]);
      }
    },
    // 弹窗提交
    dialogSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.dataForm
          };
          if (!this.dataEdit) {
            // 新增
            data_api.addParamsItem(params).then(res => {
              Message.success("添加成功");
              this.dataDialogVisible = false;
              this.getTableList();
            });
          } else {
            data_api.editParamsItem(params).then(res => {
              Message.success("修改成功");
              this.dataDialogVisible = false;
              this.getTableList();
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#params_manage {
  padding: 24px;
  .search_box {
    margin-bottom: 16px;
    line-height: 32px;
    overflow: hidden;
  }
  .el-icon-more {
    transform: rotate(90deg);
  }
  .preview_dialog {
    .preview_box {
      overflow-y: auto;
      width: 100%;
      border: 1px solid #dcdfe6;
    }
  }
  .plain_button {
    color: #505363;
    background-color: #fff;
  }
  .plain_button:hover {
    color: #00b259;
  }
  .plain_button:focus {
    color: #00b259;
  }
}
</style>

<style lang="scss">
#params_manage {
  // dialog样式重置
  .data_dialog {
    .el-dialog {
      width: 1006px;
      .el-dialog__header {
        padding: 24px 40px 10px 40px;
      }
      .el-dialog__body {
        padding: 6px 40px;
        .suffix_icon {
          width: 14px;
          height: 14px;
          position: relative;
          top: 1px;
          right: 5px;
        }
      }
    }
  }
  .preview_dialog {
    .el-dialog {
      width: 527px;
      .el-dialog__header {
        padding: 24px 40px 10px 40px;
      }
      .el-dialog__body {
        padding: 6px 40px;
      }
    }
  }

  .delete_dialog {
    .el-dialog {
      width: 428px;
      .el-dialog__header {
        padding-top: 18px;
        padding-bottom: 0;
        .el-dialog__headerbtn {
          position: absolute;
          top: 24px;
          right: 20px;
        }
      }
      .el-dialog__body {
        .warning_title {
          line-height: 22px;
          position: relative;
          padding-left: 30px;
          line-height: 24px;
          .before_icon {
            width: 24px;
            height: 22px;
            margin-right: 2px;
            vertical-align: bottom;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        .delete_tips {
          color: #505363;
          line-height: 20px;
          font-size: 14px;
          margin-top: 16px;
          text-indent: 32px;
        }
      }
    }
  }

  .el-checkbox {
    .el-checkbox__label {
      padding-left: 5px;
    }
    .is-focus {
      .el-checkbox__inner {
        border-color: #00b259;
      }
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }
}
.resource_popover .el-dropdown-menu__item:hover {
  background-color: #f5f7fa !important;
}
.resource_popover {
  .el-dropdown-menu__item span {
    color: #505363;
  }
  .green_hover:hover {
    span {
      color: #00b259;
    }
  }
  .delete_hover:hover {
    span {
      color: #e60000;
    }
  }
}
</style>
